export default class Esigner {
    constructor(
        public email: string,
        public firstName: string,
        public lastName: string,
        public phoneNumber: string,
        public cedula: string
    ) {}
}